import React, { useEffect, useState } from 'react';
import SelectDropdown from '../../../../Components/SelectDropdown';
import { ProductThumb } from '../../../../Components/Product/ProductThumb';

export default function AutocompleteContainer({
	autocompleteValue,
	value,
	onAutocomplete,
	onChange,
	label,
	labelPosition,
	color,
	size = 'm',
	emptyState,
	autocompletePlaceholder = 'Search for a product ID',
	searchProductFeed,
	needTenantForSearch,
	tenanSelected,
}) {

	const [list, setList] = useState([]);
	const [datas, setDatas] = useState([]);
	const [autocompleteListIsLoading, setautocompleteListIsLoading] = useState(false);

	if(!value) return <></>;

	function sortArrayProducts(a, b) {
		if (a.id < b.id) return -1;
		if (a.id > b.id) return 1;
		return 0;
	}

	const getListOfSpecificities = () => {
		setautocompleteListIsLoading(true);
		if (!needTenantForSearch) {
			searchProductFeed.postSearchEmptyTenant(
				{
					'searchTerm': autocompleteValue,
					'requestedFields': ['NameAndThumbnail'],
					limit: 40,
				},
				(data) => {
					setautocompleteListIsLoading(false);
					setDatas([...data.products.sort(sortArrayProducts)]);
				},
				(error) => {
					console.log('=>(SearchProduct.tsx:77) error', error);
				}
			);
		} else {
			searchProductFeed.postSearchWithTenant(
				{
					'searchTerm': autocompleteValue,
					'requestedFields': ['NameAndThumbnail'],
					limit: 40,
				},
				tenanSelected,
				(data) => {
					setDatas([...data.products.sort(sortArrayProducts)]);
					setautocompleteListIsLoading(false);
				},
				(error) => {
					console.log('=>(SearchProduct.tsx:77) error', error);
					setautocompleteListIsLoading(false);
				}
			);
		}
	};

	useEffect(() => {
		if (autocompleteValue && autocompleteValue.length !== 0) {
			getListOfSpecificities();
		}
	}, [autocompleteValue]);

	useEffect(() => {
		const formattedList = datas.map(product => ({
			label: product.name,
			value: product.id,
			children: <ListItem
				id={product.id}
				imageUrl={product.urlThumbnail}
				label={product.name}
			/>
		}));
		setList(formattedList);
	}, [datas]);

	function onAutoSelect(val) {
		const newValue = list.find(el => el.value === val);
		onChange(newValue);
	}

	return (
		<>
			<SelectDropdown
				optionsList={list}
				value={value.value}
				onChange={(v) => onAutoSelect(v)}
				friendlyValue={value.label}
				autocomplete={true}
				autocompleteIsLoading={autocompleteListIsLoading}
				autocompleteValue={autocompleteValue}
				autocompletePlaceholder={autocompletePlaceholder}
				autocompleteDelay={500}
				onAutocomplete={(v) => onAutocomplete(v)}
				label={label}
				labelPosition={labelPosition}
				color={color}
				emptyState={emptyState}
				size={size}
			/>
		</>
	);
}

function ListItem({
	id,
	label,
	imageUrl
}) {
	return (
		<div className='flex'>
			<div className='flex_item_fix'>
				<ProductThumb
					url={imageUrl}
					width={40}
				/>
			</div>
			<div className='flex_item_full'>
				<div>{label}</div>
				<div className='s_13 grey_3 mt_3'>{id}</div>
			</div>
		</div>
	);
}
